import { TreeItem, useTreeItemModel } from '@mui/x-tree-view-pro';

import { LibraryTagTreeItem } from 'types';

import { MuiChangeEvent, TagTreeSelectItemProps } from './types';

export const TagTreeSelectItem = ({
  onGroupToggle,
  groupStatusMap,
  hideGroupCheckbox,
  ...props
}: TagTreeSelectItemProps) => {
  const item = useTreeItemModel<LibraryTagTreeItem>(props.itemId);

  const groupStatus =
    item?.isGroup && onGroupToggle
      ? groupStatusMap?.get(props.itemId)
      : undefined;

  return (
    <TreeItem
      {...props}
      slotProps={{
        ...props.slotProps,
        checkbox: {
          ...props.slotProps?.checkbox,
          ...(groupStatus &&
            onGroupToggle && {
              checked: groupStatus.checked,
              indeterminate: groupStatus.indeterminate,
              onChange: (e: MuiChangeEvent) => {
                e.defaultMuiPrevented = true;
                onGroupToggle(props.itemId);
              },
            }),
          style:
            item?.isGroup && hideGroupCheckbox
              ? { display: 'none' }
              : undefined,
        } as any,
      }}
    />
  );
};
